import React from 'react';
import AdressPicker from '../../../elements/AdressPicker';

interface AdressListProp {
  list: AddressListEntry[];
}

export interface AddressListEntry {
  adress_id: number;

  gender: string;
  company: string;
  firstname: string;
  lastname: string;
  stret: string;
  house_number: string;
  postcode: string;
  city: string;
  department: string;
  additive1: string;
  additive2: string;
  country_id: number;
  country_name: string;
  iso_code_2: string;
  isBillingAddress: boolean;
  isShippingAddress: boolean;
  isShippingDefault: boolean;
  isBillingDefault: boolean;
}

export default class AdressList extends React.Component<AdressListProp> {
  render(): React.ReactNode {
    const { list } = this.props;

    const billing = list.filter((a) => a.isBillingAddress);
    const shipping = list.filter((a) => a.isShippingAddress);
    const sonstige = list.filter((a) => !a.isBillingAddress && !a.isShippingAddress);

    const hasDefaultBilling = list.some((a) => a.isBillingDefault);
    const hasDefaultShipping = list.some((a) => a.isShippingDefault);

    return (
      <div id="addressList">
        {!hasDefaultBilling && (
          <div style={{ color: '#c20f0d', fontWeight: 'bold', marginBottom: '6px' }}>
            Keine Standard-Rechnungsadresse gesetzt
          </div>
        )}
        {!hasDefaultShipping && (
          <div style={{ color: '#c20f0d', fontWeight: 'bold', marginBottom: '6px' }}>
            Keine Standard-Versandadresse gesetzt
          </div>
        )}

        <h3>Rechnungsadressen</h3>
        <AdressPicker list={billing} showBadges={true} />

        <h3>Lieferadressen</h3>
        <AdressPicker list={shipping} showBadges={true} isLieferTermin={true} />

        {sonstige.length > 0 && (
          <>
            <h3>Sonstige</h3>
            <AdressPicker list={sonstige} showBadges={true} />
          </>
        )}

        <br />
        <button
          onClick={() => {
            window.historyHelper.memory.push('/konto/address/new', null);
          }}
        >
          Neue Adresse
        </button>
      </div>
    );
  }
}
